import React from 'react';
import AudioWaveform from '../AudioWaveform.tsx';
import VideoPlayer from '../VideoPlayer.tsx';
import OptimizedImageContent from '../OptimizedImageContent.tsx';
import { useWorkflowMessageMedia } from '../../hooks/useWorkflowMessageMedia.ts';

export default function WorkflowMediaContent({ assetId, kind, messageId, isOwn }: {
  assetId: string; kind: 'image' | 'audio' | 'video'; messageId?: number | null; isOwn: boolean;
}) {
  const media = useWorkflowMessageMedia(assetId, kind, messageId);
  if (media.status === 'idle') return <button className="min-h-11 rounded-xl border border-current/20 px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-sminy-primary" onClick={media.prepare}>Carregar {kind === 'audio' ? 'áudio' : 'vídeo'}</button>;
  if (media.status === 'loading') return <p role="status" className="py-3 text-sm">Carregando mídia...</p>;
  if (!media.src) return <p className="py-3 text-sm">Mídia indisponível.</p>;
  if (kind === 'image') return <OptimizedImageContent src={media.src} alt="Imagem compartilhada" isOwn={isOwn} />;
  if (kind === 'video') return <VideoPlayer src={media.src} fromMe={isOwn} messageColor={isOwn ? 'dark' : 'light'} />;
  return <AudioWaveform src={media.src} fromMe={isOwn} messageColor={isOwn ? 'light' : 'dark'} />;
}
